export default [
	{
		location: 'Retailer Program Widget',
		selector: '.ws-subaru-prgrm-logos *'
	},
	{
		location: 'Corporate Cell',
		selector:
			'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list *'
	},
	{
		location: 'Share The Love',
		selector:
			'.ws-subaru-stl :is(a[href*="/share-the-love/submission-form.html"], a.national-charity-btn)'
	},
	{
		location: 'Flex Banner',
		selector: 'a.soa-wiapi-footer-banner'
	}
];
